import React from 'react';
interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}
export function Card({
  title,
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-lg shadow overflow-hidden ${className}`} data-id="element-81">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-82">
        <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-83">{title}</h3>
      </div>
      <div className="px-4 py-5 sm:p-6" data-id="element-84">{children}</div>
    </div>;
}